import { useEffect } from "react"

import useFetch from "shared/model/useFetch"

const useGetAccountSeedTicket = () => {
    const [fetchResult, fetchRequest] = useFetch()

    useEffect(() => {
        fetchRequest("GET", "/account/seed-ticket")
    }, [])

    return [fetchResult]
}

export default useGetAccountSeedTicket